import * as React from 'react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import {
  Col, Flex, Image, Row, Spin,
} from 'antd';
import styled from 'styled-components';
import { LoadingOutlined } from '@ant-design/icons';
import { Helmet } from 'react-helmet-async';
import { DivMinWidth, FlexPadStyled } from '../App';
import { fetchListEvent } from '../store/slices/awmacSlice';
import { AppDispatch, RootState } from '../store';
import { LogoBC } from '../components/LogoBC';
import { Breadcrumbs } from '../components/Breadcrumbs';
import { colors, fonts } from '../assets/constStyles';
import PhotographerInfo from '../components/PhotographerInfo';

const ImageWrapper = styled.div`
  width: 100%;
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background-color: ${colors.colorGrey};

  && {    
    .ant-image{
      height: 100% !important;
      width: 100%;
    }

    .ant-image-img {
      height: 100% !important;
      width: 100%;
      object-fit: cover;
      object-position: center;
      display: block;
    }
`;

const StyledImage = styled(Image)`
  max-width: 100%;
  max-height: 100%;
  object-fit: cover;
  object-position: center;
  display: block;
`;

export const EventPhotosPage = () => {
  const { year } = useParams();
  const dispatch = useDispatch<AppDispatch>();
  const listEventPhotos = useSelector((state: RootState) => state.awmac.awmacEventList);
  const awmacLoader = useSelector<RootState, boolean>((state) => state.awmac.awmacLoader);

  useEffect(() => {
    if (year) {
      const yearNumber = Number(year);
      (async () => {
        try {
          dispatch(fetchListEvent(yearNumber));
        } catch (e) {
          console.log(e);
        }
      })();
    }
  }, [dispatch]);

  return <>
      <Helmet>
          <title>EVENT-{year}</title>
          <meta
              name="description"
              content="AWMAC - Architectural Woodwork Manufacturers Association of Canada AWARDS"
          />
          <link rel="canonical" href={`https://awmacbc.com/events/${year}`}/>
      </Helmet>
        <Spin spinning={awmacLoader} style={{ minHeight: 400 }} tip={'Please wait ...'} indicator={<LoadingOutlined style={{ fontSize: 50 }}/>}>
            <DivMinWidth>
                <div style={{ padding: '20px' }}>
                    <FlexPadStyled vertical>
                        <LogoBC/>
                    </FlexPadStyled>
                    <Flex style={{ margin: '20px 0' }}>
                        <Breadcrumbs/>
                    </Flex>
                    <h1 style={{ textAlign: 'center', fontFamily: fonts.font2, marginBottom: '20px' }}>AWMAC AWARDS OF
                        EXCELLENCE - {year}</h1>
                    <Flex justify={'flex-end'} style={{ marginBottom: 10 }}>
                        {
                            <PhotographerInfo year={year} />
                        }
                    </Flex>
                    <Row align="stretch" gutter={[20, 20]} id={'image_wrapper'}>
                        <Image.PreviewGroup>
                            {
                                listEventPhotos.map((img, index) => {
                                  const imageUrl = `${process.env.REACT_APP_S3_STORAGE_URL_EVENT}/${process.env.REACT_APP_BUCKET_EVENT}/${year}-Event-photos/${img}`;

                                  return (
                                        <Col xs={24} sm={8} md={8} lg={8} key={index}>
                                            <ImageWrapper >
                                                <StyledImage
                                                    src={imageUrl}
                                                />
                                            </ImageWrapper>

                                        </Col>
                                  );
                                })
                            }
                        </Image.PreviewGroup>
                    </Row>
                </div>
            </DivMinWidth>
        </Spin>
    </>;
};
